module.exports = __webpack_public_path__ + "img/Recruitment System (Screening and Evaluation) - UST.cc0674ee.svg";